import { CustomerTemplate, FieldError, FieldInfo, SignatureInfo } from "../../../src/types";
import { languages, checkLineCount, combineErrors, signatureInfo, size, getContentField } from "./shared";

const birthdayText = '„ Altwerden ist wie auf einen Berg steigen: Je höher man steigt, desto mehr schwinden die Kräfte, aber umso weiter sieht man. “ - ( Ingmar Bergmann )'


export const birthdayTemplateData: CustomerTemplate = {
    key: 'birthday',
    name: {
        de: 'Geburtstagskarte',
        en: 'Birthday card'
    },
    ...size,
    languages,
    signatureInfo,
    templateData: [
        {
            key: 'headlineTop',
            name: {
                en: 'Headline Top',
                de: 'Überschrift obere Zeile'
            },
            languageData: {
                'de': 'Alles Gute',
                'en': 'Happy'
            },
            maxLength: 15,
            hide: false,
            isValid: combineErrors([checkLineCount(1)])
        },
        {
            key: 'headlineBottom',
            name: {
                en: 'Headline Bottom',
                de: 'Überschrift untere Zeile'
            },
            languageData: {
                'de': 'zum Geburtstag',
                'en': 'Birthday'
            },
            maxLength: 15,
            hide: false,
            isValid: combineErrors([checkLineCount(1)])
        },
        getContentField(birthdayText)
    ],
    font: {
        headlineTop: {
            family: 'Cookie-Regular',
            color: '#000', 
            size: 55,
            TopPadding: 285,
            lineHeight: 55
        },
        headlineBottom: {
            family: 'Cookie-Regular',
            color: '#000', 
            size: 55,
            TopPadding: 285,
            lineHeight: 48
        },
        content: {
            family: 'Poppins-Regular',
            color: '#000', 
            size: 16,
            TopPadding: 385,
            lineHeight: 20
        },
        doubleHeadline: true
    },
    signature: {
        topPadding: 355,
        contentDep: true,
        singleSignature: false,
        fontSize: 30,
        fontSizeSub: 10,
        color: '#000'
    }     
}